import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "@/services/api/apiService";

const PORT = import.meta.env.VITE_COOK_PORT;
const MASTERURL = import.meta.env.VITE_API_COOK_URL;

// Define the shape of your state
interface FoodApprovalItem {
    foodMenuName: any;
    kitchenName: any;
    description: any;
    lastName: any;
    firstName: any;
    category: string;
    quantityAvailable: number;
    priceOverride: any;
    deliveryStartTime(deliveryStartTime: any): import("react").ReactNode;
    deliveryEndTime(deliveryEndTime: any): import("react").ReactNode;
    scheduledDate(scheduledDate: any): import("react").ReactNode;
    preorderClosingDatetime: string | number | Date;
    mealTypeName: any;
    foodImageUrl: string | undefined;
    name: any;
    price: any;
    specialMention: any;
    foodMenuItemId: any;
    // define actual fields if you know them
    id: number;
    menuTitle: string;
    // Add other fields as per your API response
    foodName: string;
}

interface FoodApprovalState {
    data: FoodApprovalItem[];
    loading: boolean;
    error: string | null | {};
}

// Initial state
const initialState: FoodApprovalState = {
    data: [],
    loading: false,
    error: null,
};

interface ApiResponse {
    data: FoodApprovalItem[];

}
// Async thunk
export const fetchfoodListing = createAsyncThunk<FoodApprovalItem[]>(
    'FoodApprovel/fetchfoodApprovelRequest',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.post<ApiResponse>(
                '/get_all_food_schedule',
                {}, // body
                PORT,
                MASTERURL
            );

            return response.data;
        } catch (error) {
            return rejectWithValue("Failed to fetch food Listing");
        }
    }
);


// Slice
const foodListing = createSlice({
    name: 'FoodListing',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchfoodListing.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchfoodListing.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchfoodListing.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? "Unknown error";
            });
    },
});

export default foodListing.reducer;
